export const CURRENT_RELEASE_TIMESTAMP = 1673594746;
export const URL_ICP = "https://beian.miit.gov.cn/";
export const URL_ICP_NAME = "京ICP备20011524号-1";
export const NAME_WEBSITE = "Copyright ©2022-2026 honitree.com";

/**
 * 将豆瓣封面 URL 转为本地反代路径
 * 例: https://img2.doubanio.com/view/subject/m/public/s29643861.jpg
 *   → /cover/img2/m/s29643861.jpg
 * 例: https://img2.doubanio.com/view/subject/l/public/s33917631.jpg
 *   → /cover/img2/l/s33917631.jpg
 */
export const toCoverProxyPath = (coverUrl: string): string => {
  return coverUrl.replace(
    /https:\/\/(img\d)\.doubanio\.com\/view\/subject\/([a-z]+)\/public\//,
    "/cover/$1/$2/",
  );
};
